<template>
  <div class="hello">
    <header class="helloWord" >
      <!--<a href="index.html" class="backlastpage"></a>-->
      <div style="padding-top: 15px;padding-left: 1px">{{newTime}}</div>
      <div class="headerPhoto">
        <img src="@/assets/img/10.png" style="width: 25px;height: 22px" alt="">
        <img src="@/assets/img/11.png" style="width: 25px;height: 22px" alt="">
      </div>
      <!--<span class="positionHeaderS">推荐</span>-->
      <!--<van-icon name="scan" size="25" />-->
      <!--<van-icon name="setting" />-->
    </header>

    <div style="padding: 65px 10px">
      <!--<router-link to="editResume">-->
      <!--<div class="top divflex">-->
        <!--<div v-if="list.name" class="username" >{{list.name}}</div>-->
        <!--<div v-else class="username" style="font-size: 15px;color: #f56723">请完善个人资料</div>-->
        <!--&lt;!&ndash;<div class="username" >{{list.name}}</div>&ndash;&gt;-->
        <!--<img v-if="list.photo" class="tx" :src="list.photo" alt="">-->
        <!--<img v-else class="tx" src="@/assets/img/tx.jpg" alt="">-->
        <!--&lt;!&ndash;<img v-else="list.photo" class="tx"  alt="">&ndash;&gt;-->
        <!--<div class="bianji">-->
          <!--<img class="edit" src="../assets/img/edit.jpg" alt="">-->
         <!--<span class="word">在线简历</span>-->

        <!--</div>-->
      <!--</div>-->
      <!--</router-link>-->
      <router-link to="editResume">
      <div class="editUser">
          <div class="editUserLeft">
          <p style="font-size: 20px;font-weight: 600" v-if="list.name">{{list.name}}</p>
            <!--<div v-else class="username" style="font-size: 20px;font-weight: 600">请完善个人资料</div>-->
            <div v-else class="username" style="font-size: 15px;color: #f56723">请完善个人资料</div>
          <p style="display: flex;align-items: center">

            <img src="@/assets/img/edit.jpg" alt="">
            <span>在线简历</span>
            </p>

          </div>
          <div class="editUserRight">
            <img v-if="list.photo" class="tx" :src="list.photo" alt="">
            <img v-else class="" src="@/assets/img/tx.jpg" alt="">
          </div>
      </div>
      </router-link>
      <div class="dynamic">
        <div class="dynamicDiv">
        <span v-show="list.news_num!=null" >{{list.news_num}}</span>
        <span >动态</span>
        </div>
        <div class="dynamicDiv">
          <span v-show="list.like_num!=null" >{{list.like_num}}</span>
          <span >我的关注</span>
        </div>
        <div class="dynamicDiv">
          <span v-show="list.fans_num!=null">{{list.fans_num}}</span>
          <span >粉丝</span>
        </div>
        <div class="dynamicDiv">
          <span v-show="list.follow_num!=null" >{{list.follow_num}}</span>
          <span >点赞</span>
        </div>
      </div>
      <!--<div class="vip">-->
        <!--&lt;!&ndash;<span class="vipword">VIP</span>升级vip享专属权益  <a class="sj" href="#">去升级</a>&ndash;&gt;-->
        <!--<img src="@/assets/img/15.png" alt="">-->
      <!--</div>-->
      <div class="vipDiv" :style="style">
        <div class="vipDivImg" style="width: 5rem">
          <img style="width: 100%;height: 100%" src="@/assets/img/9.png" alt="">
        </div>

        <!--<span class="vipword">VIP</span>升级vip享专属权益  <a class="sj" href="#">去升级</a>-->
        <!--<img src="@/assets/img/vip.png" alt="">-->
      </div>
      <br>
      <hr>
      <div class="list">
        <!--<div class="qzzs">-->
        <div class="jobList">
          <!--<span class="qzzsword">求职助手</span>-->
          <p>求职助手</p>
          <div style="display: flex;justify-content: space-between">
            <div class="listjl">
              <span>简历曝光 &ensp;</span>
              <img style="width: 30px" src="@/assets/img/14.png" alt="">
            </div>
            <div class="listjz">
              <span>竞争力分析</span>
              <img style="width: 30px" src="@/assets/img/15.png" alt="">

            </div>

          </div>
        </div>
        <ul class="listResume">

          <router-link to="/sendResume"><li><span class="listResumes1"><img src="@/assets/img/16.png" alt=""><span>附件简历</span></span><span class="listResumes2" >已上传2份</span></li></router-link>

          <li><span class="listResumes1" @click="tojobWanted(list.id)"><img src="@/assets/img/17.png" alt=""><span>管理求职意向</span></span>
            <!--<span class="listResumes2" ></span>-->
            <span v-if="list.jobstatus==0||list.jobstatus==null" class="listResumes2">请选择</span>
            <span v-else-if="list.jobstatus==1" class="listResumes2">离职随时到岗</span>
            <span v-else-if="list.jobstatus==2" class="listResumes2">在职月内到岗</span>
            <span v-else-if="list.jobstatus==3" class="listResumes2">在职考虑机会</span>
            <span v-else-if="list.jobstatus==4" class="listResumes2">在职暂不考虑</span>
          </li>
          <li><span class="listResumes1"><img src="@/assets/img/18.png" alt=""><span>技能证书</span></span><span class="listResumes2" ></span></li>
          <li><span class="listResumes1"><img src="@/assets/img/19.png" alt=""><span>提升简历曝光</span></span><span class="listResumes2" ></span></li>

        </ul>
        <ul class="listResume">
         <li @click="toHome"><span class="listResumes1"><span>切换身份</span></span><span class="listResumes2" >切换至我要招人才</span></li>
          <router-link to="/changePassWord"><li><span class="listResumes1"><span>账号安全</span></span><span class="listResumes2" >修改登录密码</span></li></router-link>
          <router-link to="/setPassWord"><li><span class="listResumes1"><span>设置密码</span></span><span class="listResumes2" ></span></li></router-link>
          <li><span class="listResumes1"><span>关于我们</span></span><span class="listResumes2" ></span></li>
        </ul>
      </div>
      <a href="javascript:;" class="exitLogin" v-on:click="go">退出登录</a>
    </div>
    <van-tabbar route >
      <van-tabbar-item replace to="/" icon="wap-home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/position" icon="envelop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace @click="href()" icon="fire-o">
        <!--<van-icon name="fire-o" />-->
        社保
      </van-tabbar-item>
      <van-tabbar-item replace to="/firstMessage" icon="desktop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/HelloWorld" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  import pic from '@/assets/img/vip.png'
  import  popover  from 'vant';
  const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
  var icnow = new Date();      // 初始化时间
  var interval;
//  import axios from '../utils/axios.js'
//  import {postFormAPI} from '../utils/api.js'
//  import  http from '../utils/http.js'
  import  fatch from '../utils/https/https.js'
import { apiAddress } from '@/utils/https/api';// 导入我们的api接口
import { Button } from 'vant'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      list:{
        name:''
      },
      style:{
      backgroundImage:`url(${pic})`
      },
      year: icnow.getFullYear(),
      month: icnow.getMonth() + 1,
      date: icnow.getDate(),
      day: days[icnow.getDay() - 1],
      time: icnow.toTimeString().substring(0, 8),
    }
  },
  mounted(){
    this.onLoad()
  },
  created () {
    interval = setInterval(() =>{
      let icnow = new Date();
      this.year = icnow.getFullYear();
      this.month = icnow.getMonth() + 1;
      this.date = icnow.getDate();
      this.day = days[icnow.getDay()];
      this.time = icnow.toTimeString().substring(0, 8);
    }, 1000)
  },
  computed: {
    // 当前时间
    newTime: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
      return this.month + '月' + this.date + '日' + this.time;
    }
    },
  methods:{
    href(){
      window.location.href = 'https://m.shangshebao.com';
    },
    toHome(){
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,

      });
      setTimeout(() => {
        this.$router.push("/comMy")
      }, 2000);
    },
  go(){
    localStorage.removeItem('userid')
    this.$router.push({ path:'/log'  })
  },
    tojobWanted(id){
      this.$router.push({
       path:"/jobWanted",
       query:{
         id:id
       }
       })
    },
    onLoad() {
      this.$api.obtainMy({'userid':localStorage.getItem("userid")})
        .then(res=>{
        this.list=res.data?res.data[0]:{}
      })
        .catch(err=>{

      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*@import '../assets/css/common.css';*/
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  /*@import '../assets/css/my1.css';*/
  .helloWord{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;

    color: #FFFFFF;
    z-index: 100;
  }
  /*header img{*/
    /*width: 20px;*/
    /*height: 20px;*/
  /*}*/
  .headerPhoto{
   float: right;
    margin-top: -2px;
    margin-right: 24px;
  }
  .headerPhoto img{
    padding-left: 10px;
  }
.vipDivImg{
  width: 5rem;
  right: 34px;
  float: right;
  margin: 20px;
}
  .dynamic{
    display: flex;
    justify-content: space-evenly;
    /*padding-bottom: 1rem;*/
    padding: 0.5rem 0;
  }
  .age{
    font-size: 13px;
  }
  .dynamicDiv{
    /*display: flex;*/
  }
  .dynamicDiv span{
    display: block;
    text-align: center;
  }
  .vipDiv{
    width: 90%;
    margin: auto;
    height: 4rem;
    /*background-image:url("../assets/img/vip.png");*/
    /*background-color: #fff;*/
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .vipDiv img{
    width: 100%;
    height: 100%;
  }
  .editUser{
    display: flex;
    /*justify-content: center;*/
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    padding-top: 15px;
  }
  .editUserRight img{
    width: 100%;
    border-radius: 100%;

  }
  .editUserRight{
    width: 80px;
    height: 80px;
  }
  .editUserLeft img{
   width: 20px;
    height: 20px;
  }
  .jobList{

  }
  .listjl{
    /*width: 30%;*/
    height: 56px;
    background: #fff;
    /*float: left;*/
    /*margin-top: 16px;*/
    /*margin-left: 40px;*/
    border-radius: 14px;
    border: 1px solid #999999;
    box-shadow: 2px 2px 2px #999999;
    /*text-align: center;*/
    /*line-height: 56px;*/
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 1px 5px;
  }
  .listjz{
    /*width: 30%;*/
    height: 56px;
    background: #fff;
    /*float: right;*/
    /*margin-top: 16px;*/
    /*margin-right: 40px;*/
    border-radius: 14px;
    border: 1px solid #999999;
    box-shadow: 2px 2px 2px #999999;
    /*text-align: center;*/
    /*line-height: 56px;*/
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 1px 5px;
  }
  .listResume{
    line-height: 44px;
    margin-top: 10px;
    padding: 0 6px;
  }
  .listResume img {
    width: 20px;
    height:20px;
    padding-right: 10px;
  }
  .listResume li{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .listResumes2{
    font-size: 12px;
    color: #c1c0c0;
  }
  .listResumes1{
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  .exitLogin{
    display: block;
    width: 100%;
    line-height: 40px;
    text-align: center;
    color: red;
    background-color: #fff;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue